module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarX-4.4210d583.png";